<template>
  <div class="title">
    <div class="container">
      <div class="row">
        <div v-if="icon" class="col icon pr-2">
          <Icon
            :icon="icon"
            :width="45"
            colour="#212529"
          />
        </div>
        <div class="col ml-0">
          <h1 v-if="heading" class="h3 mb-0">{{ heading }}</h1>
          <p v-if="subHeading">{{ subHeading }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Icons/Icon';

export default {
  components: {
    Icon,
  },

  props: {
    icon: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
  },
};
</script>
